module.exports = __webpack_public_path__ + "img/20190523205537微信截图_20190523205817.67ff3958.png";